import { useState, useEffect, useContext } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ConfigContext } from "../../../Context/ConfigContext";
import { useTranslation } from 'react-i18next';
import { OverlayLoader } from "../../../Components/Shimmers";
import CartItem from "../CartItem";
import { CartsContext } from "../../../Context/CartsContext";

function BasketCart() {

    const { apiURL, setIsCartUpdate, currency } = useContext(ConfigContext);
    const { cartItems, coupon, setCoupon, cartLoading, cartData } = useContext(CartsContext);

    const [couponData, setCouponData] = useState([]);

    useEffect(() => {
        GetCoupons();
    }, []);

    const GetCoupons = async () => {

        try {
            const response = await axios.get(`${apiURL}/Home/GetCoupons?lang=en`);
            const data = response.data.data;
            if (data) {
                setCouponData(data);
            } else {
                console.log("No Coupons Found");
            }
        } catch (err) {
            console.log("err Something Went Wrong", err);
        }
    };

    const handleCouponCodeChange = (e) => {
        setCoupon(e.target.value);
    };

    const RemoveCoupon = () => {
        localStorage.removeItem("coupon");
        setCoupon("");
        setIsCartUpdate(prev => !prev)
    };

    const ApplyCoupon = async (couponCode, e) => {
        if (couponCode) {
            e.preventDefault();
            localStorage.setItem("coupon", couponCode);
            setCoupon(couponCode);
            setIsCartUpdate(prev => !prev)
        }
    };

    const { t } = useTranslation();
    const dir = localStorage.getItem('dir');

    const hasOutOfStock = cartItems?.some((item) => item?.part_available === false);

    return (
        <>
            {
                cartLoading ?
                    <div style={{ height: "70vh" }}>
                        <OverlayLoader />
                    </div>
                    :
                    <main className="main" dir={dir} style={{ textAlign: dir === 'rtl' ? 'right' : '' }}>
                        <ToastContainer
                            position="bottom-center"
                            autoClose={1000}
                            newestOnTop={false}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            theme="dark"
                            closeButton={false}
                            hideProgressBar
                        />
                        <div className="container mt-4">
                            <div className="row">
                                <div className={`col-lg-8 ${dir === 'rtl' ? 'text-right' : 'text-left'} mb-1`} >
                                    <NavLink to="/" className="cart-return text-left">
                                        <i className={`fas fa-arrow-${dir === 'rtl' ? 'right ml-2' : 'left mr-2'} `}></i>
                                        <span>{t('continue_shopping')}</span>
                                    </NavLink>
                                </div>
                            </div>

                            {
                                cartItems && cartItems?.length > 0 ? (
                                    <div className="row">
                                        <div className="col-lg-8">
                                            <div className="cart-table-container">
                                                {cartItems && cartItems?.map((item, index) => (
                                                    <CartItem item={item} index={index} />
                                                ))}

                                            </div>
                                        </div>

                                        <div className="col-lg-4">
                                            <div className="cart-summary">
                                                <h3 className="">{t("order_summary")}</h3>
                                                <div className="float-left" style={{ width: '100%' }}>
                                                    <div className="cart-discount" >
                                                        <form action="#">
                                                            <div className="input-group">
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm"
                                                                    placeholder={t("coupon_code")}
                                                                    value={coupon}
                                                                    onChange={handleCouponCodeChange}
                                                                    required
                                                                    disabled={
                                                                        localStorage.getItem("coupon") && localStorage.getItem("coupon") !== 'null' ? true : false
                                                                    }
                                                                />
                                                                {localStorage.getItem("coupon") && localStorage.getItem("coupon") !== 'null' ? (
                                                                    <div className="input-group-append">
                                                                        <button
                                                                            className="btn btn-sm btn-primary"
                                                                            type="button"
                                                                            onClick={RemoveCoupon}
                                                                        >
                                                                            {t("remove_coupon")}

                                                                        </button>
                                                                    </div>
                                                                ) : (
                                                                    <div className="input-group-append">
                                                                        <button
                                                                            className="btn btn-sm btn-primary"
                                                                            type="button"
                                                                            onClick={(e) => ApplyCoupon(coupon, e)}
                                                                        >
                                                                            {t("apply_coupon")}
                                                                        </button>
                                                                    </div>
                                                                )}

                                                            </div>

                                                            {cartData && cartData?.coupon.coupon_code !== "" && (
                                                                cartData?.coupon.coupon === false ?
                                                                    <div className="alert alert-danger">{cartData?.coupon?.message}</div>
                                                                    :
                                                                    <div className="alert alert-success">{cartData?.coupon?.message}</div>)
                                                            }

                                                        </form>

                                                        <div
                                                            className="modal fade"
                                                            id="CouponModel"
                                                            tabindex="-1"
                                                            role="dialog"
                                                            aria-labelledby="exampleModalCenterTitle"
                                                            aria-hidden="true"
                                                        >
                                                            <div
                                                                className="modal-dialog modal-dialog-centered"
                                                                role="document"
                                                            >
                                                                <div className="modal-content w-75 ml-5">
                                                                    <div className="modal-header">
                                                                        <h5
                                                                            className="modal-title mb-0"
                                                                            style={{
                                                                                fontSize: "20px",
                                                                                color: "#404553",
                                                                                fontWeight: "medium",
                                                                            }}
                                                                            id="exampleModalLongTitle"
                                                                        >
                                                                            {t("available_offers")}
                                                                        </h5>
                                                                        <button
                                                                            type="button"
                                                                            className="close h3"
                                                                            data-dismiss="modal"
                                                                            aria-label="Close"
                                                                        >
                                                                            <span aria-hidden="true">×</span>
                                                                        </button>
                                                                    </div>
                                                                    <div className="modal-body">
                                                                        <h4>{t("coupon_offers")}</h4>

                                                                        {couponData && couponData.length > 0 ? (
                                                                            couponData.map((item) => (
                                                                                <div
                                                                                    className="main-Featured card"
                                                                                    style={{
                                                                                        background: "white",
                                                                                        borderRadius: "10px",
                                                                                    }}
                                                                                >
                                                                                    <div
                                                                                        className="card-header d-flex align-items-center"
                                                                                        style={{
                                                                                            background: "white",
                                                                                            borderRadius: "10px",
                                                                                            borderBottom: "1px solid #dddddd",
                                                                                            borderBottomRightRadius: "0px",
                                                                                            borderBottomLeftRadius: "0px",
                                                                                        }}
                                                                                    >
                                                                                        <img
                                                                                            src={`${process.env.PUBLIC_URL}/assets/images/Files/Cart/coupon-discount.svg`}
                                                                                            alt="coupon-discount-image"
                                                                                            width={20}
                                                                                            height={20}
                                                                                        />{" "}
                                                                                        <span className="ml-3">
                                                                                            {item.coupon_title}
                                                                                        </span>
                                                                                    </div>
                                                                                    <div className="p-4">

                                                                                        <span>{item.coupon_description}</span>
                                                                                    </div>
                                                                                    <div className="d-flex justify-content-between  align-items-center">
                                                                                        <h4
                                                                                            className="text-success text-center alert-success ml-4"
                                                                                            style={{
                                                                                                padding: "2px 10px",
                                                                                                border: "1px dashed rgb(40, 167, 69)",
                                                                                            }}
                                                                                        >
                                                                                            {item.coupon_code}
                                                                                        </h4>
                                                                                        {localStorage.getItem("coupon") === item.coupon_code ? (
                                                                                            <button className="btn btn-success Apply mr-4 mb-1">
                                                                                                {t("applied")}
                                                                                            </button>
                                                                                        ) : (
                                                                                            <button
                                                                                                className="btn btn-primary Apply mr-4 mb-1"
                                                                                                data-dismiss="modal"
                                                                                                onClick={(e) => ApplyCoupon(item.coupon_code, e)}
                                                                                            >
                                                                                                {t("apply")}
                                                                                            </button>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            ))
                                                                        ) : (
                                                                            <h1>{t("no_offers")}</h1>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {cartItems && (
                                                    <>

                                                        <table
                                                            className="table table-totals"
                                                            dir={dir}
                                                            style={{ textAlign: dir === "rtl" ? "right" : "left" }}
                                                        >
                                                            <tbody>
                                                                <tr>
                                                                    <th>{t("product")}</th>
                                                                    <th className="custom-dark">{t("total")}</th>
                                                                </tr>

                                                                {cartItems?.map((item) => (
                                                                    <tr key={item.item_id}>
                                                                        <td className="custom-light">
                                                                            {item.item_title} x {item.item_qty}
                                                                        </td>
                                                                        <td className="float-right">
                                                                            {item.total_display_price}
                                                                        </td>
                                                                    </tr>
                                                                ))}

                                                                <tr>
                                                                    <td>{Number(cartData?.total_saving) > 0 ? "Sub Total" : "Taxable Amount"}</td>
                                                                    <td className="custom-dark">
                                                                        <span>{cartData?.sub_total_display}</span>
                                                                    </td>
                                                                </tr>

                                                                {localStorage.getItem("coupon") &&
                                                                    Number(cartData?.total_saving) > 0 && (
                                                                        <>
                                                                            <tr>
                                                                                <td>{t("total_saving")}</td>
                                                                                <td className="custom-dark">
                                                                                    <span className="text-success">
                                                                                        - {cartData?.total_saving_display}
                                                                                    </span>
                                                                                </td>
                                                                            </tr>

                                                                            <tr>
                                                                                {/* <td>{t("Net Amount")}</td> */}
                                                                                <td>{t("Taxable Amount")}</td>
                                                                                <td className="custom-dark">
                                                                                    <span>{cartData?.net_amount_display}</span>
                                                                                </td>
                                                                            </tr>
                                                                        </>
                                                                    )}

                                                                {Number(cartData?.vat_amount) > 0 && (
                                                                    <tr>
                                                                        <td>
                                                                            {t("VAT")} ({cartData?.vat_percent}%)
                                                                        </td>
                                                                        <td className="custom-dark">
                                                                            <span>{cartData?.vat_amount_display}</span>
                                                                        </td>
                                                                    </tr>
                                                                )}

                                                                {Number(cartData?.shipping_cost) > 0 && (
                                                                    <tr>
                                                                        <td
                                                                            style={{
                                                                                textAlign: dir === "rtl" ? "right" : "left",
                                                                            }}
                                                                        >
                                                                            {t("shipping")}
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                textAlign: dir !== "rtl" ? "right" : "left",
                                                                            }}
                                                                        >
                                                                            <span>{cartData?.display_shipping_cost}</span>
                                                                        </td>
                                                                    </tr>
                                                                )}

                                                                {Number(cartData?.cod_charges) > 0 && (
                                                                    <tr>
                                                                        <td>{t("cod_charges")}</td>
                                                                        <td className="custom-dark">
                                                                            <span>{cartData?.display_cod_charges}</span>
                                                                        </td>
                                                                    </tr>
                                                                )}

                                                                {localStorage.getItem("coupon") &&
                                                                    Number(cartData?.total_saving) > 0 && (
                                                                        <tr>
                                                                            <td colSpan={2} className="text-left">
                                                                                <div className="d-flex justify-content-center">
                                                                                    <h4
                                                                                        className="text-success text-center alert-success"
                                                                                        style={{
                                                                                            padding: "2px 10px",
                                                                                            border: "1px dashed #28a745",
                                                                                        }}
                                                                                    >
                                                                                        {t("you_will_save", {
                                                                                            value: cartData?.total_saving_display,
                                                                                        })}
                                                                                    </h4>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                            </tbody>

                                                            <tfoot>
                                                                <tr>
                                                                    <td>
                                                                        <strong>{t("grand_total")}</strong>
                                                                    </td>
                                                                    <td className="custom-dark">
                                                                        <strong>{cartData?.grand_total_display}</strong>
                                                                    </td>
                                                                </tr>
                                                            </tfoot>
                                                        </table>

                                                        <div className="checkout-methods">


                                                            {
                                                                (currency || "").toLowerCase() !== "usd" &&

                                                                <div className="alert alert-success">
                                                                    <div className="d-flex align-items-center">

                                                                        <lord-icon
                                                                            src="https://cdn.lordicon.com/nkmsrxys.json"
                                                                            trigger="loop"
                                                                            style={{ width: '60px', height: '60px' }}
                                                                        ></lord-icon>

                                                                        <div>
                                                                            You will get
                                                                            <span className="ml-2 mr-2">
                                                                                <b>{cartData?.points ?? 0} rewards points</b>
                                                                            </span>
                                                                            on this order
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            }


                                                            {hasOutOfStock ? (

                                                                <div
                                                                    className="alert alert-danger text-center mt-2"
                                                                    style={{
                                                                        fontSize: "14px",
                                                                        fontWeight: "600"
                                                                    }}
                                                                >
                                                                    Please remove out of stock items to continue checkout.
                                                                </div>

                                                            ) : (

                                                                <div
                                                                    onClick={() => {
                                                                        window.location = localStorage.getItem("token")
                                                                            ? "/basket/login"
                                                                            : "/basket/login";
                                                                    }}
                                                                    className="btn btn-block btn-dark"
                                                                >
                                                                    {t("proceed_to_checkout")}
                                                                    <i className="fa fa-arrow-right" />
                                                                </div>

                                                            )}


                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                        {/* End .col-lg-4 */}
                                    </div>
                                ) : (
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="cart-table-container  cart-summary" style={{ border: 'none', boxShadow: 'none' }}>
                                                <div className="d-flex justify-content-center">
                                                    <div>
                                                        <span style={{ fontFamily: 'Montserrat, Arial, sans-serif', fontSize: '22px', fontWeight: '500', lineHeight: '24px' }}>{t("your_cart_is_empty")}</span> <br />
                                                        <span style={{ fontSize: '15px', lineHeight: '24px', marginTop: '8px' }}>Please add items to your basket in order to buy them</span>
                                                    </div> <br />


                                                </div>
                                                {/* <div className="checkout-methods d-flex justify-content-center">
                                        <NavLink to={"/"} className="btn btn-dark btn-lg px-5">
                                            {t("shop_now")}
                                            <i className="fa fa-arrow-right" />
                                        </NavLink>
                                    </div> */}
                                            </div>
                                        </div>
                                    </div>
                                )}

                            {/* End .row */}
                        </div>
                        {/* End .container */}
                        <div className="mb-6" />
                        {/* margin */}
                    </main>
            }
        </>
    );
}

export default BasketCart;
